import { API, TM_API } from "@/utils/http"

export const getNewOrdersCount = async () => {
  const response = await API.get("/v2/seller/orders/new-count", {
    validateStatus: (status) => true
  }).catch(() => ({ data: { count: 0 } }))

  return response
}

export const getNewReturnsCount = async () => {
  const response = await API.get("/v2/seller/returns/new-count", {
    validateStatus: (status) => true
  }).catch(() => ({ data: { count: 0 } }))

  return response
}

export const getUnreadSupportTicketsCount = async () => {
  const response = await TM_API.get(`/api/customers/requests/unread/`, {
    validateStatus: (status) => true
  }).catch(() => ({ data: { count: 0 } }))

  return response
}

export const getNewInvoicesCount = async () => {
  const response = await API.get("/v2/seller/billing/invoices/new-count", {
    validateStatus: (status) => true
  }).catch(() => ({ data: { count: 0 } }))

  return response
}
